import { render, staticRenderFns } from "./TheCreateRule.vue?vue&type=template&id=06b5225a&"
import script from "./TheCreateRule.vue?vue&type=script&lang=js&"
export * from "./TheCreateRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports